'use strict';

var _ = require('lodash');
var ProfileChartDataProviderService = function ProfileChartDataProviderService($q, $filter, dataTransformerService, dataRetrieverService, dataRetrieverConstantsService, currentStateCriteriaService, featureToggleService, ProfileChartConstants, MomentService, lcaDataService, profileChartSearchCriteriaService, flightModeService) {
  var selectedDimension = 'REGULAR';
  var rmNumberFormat = $filter('rmNumberFormat');
  function cloneDataRetriever(screen, mode, masterData) {
    var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService[screen], mode);
    var clonedDataRetriever = _.cloneDeep(dataRetriever);
    clonedDataRetriever.defaultSortDefer = $q.all();
    clonedDataRetriever.defaultSortCriteriaPromise = clonedDataRetriever.defaultSortDefer.promise;
    if (masterData && _.isArray(masterData) && masterData.length > 0) {
      switch (screen) {
        case dataRetrieverConstantsService.MARKET_SCREEN:
          clonedDataRetriever.setCustomSearchCriteriaRules(profileChartSearchCriteriaService.createProfileSearchRulesForMarketScreen(masterData, selectedDimension));
          break;
        case dataRetrieverConstantsService.FLIGHT_SCREEN:
          clonedDataRetriever.setCustomSearchCriteriaRules(profileChartSearchCriteriaService.createProfileSearchRulesForFlightScreen(masterData, selectedDimension));
          break;
      }
    }
    return clonedDataRetriever;
  }
  function updateLegMarketRule(clonedDataRetriever, selectedService) {
    var marketRule = _.find(clonedDataRetriever.customSearchCriteria, ['field', 'legs.market']);
    if (marketRule) {
      marketRule.leftOperand = [selectedService.leg];
    }
  }
  function getDepartureDateOperand(dateRange, selectedService) {
    return selectedService ? selectedService.legDepartureDateMoment ? MomentService.of(selectedService.legDepartureDateMoment.value, MomentService.FIELD.ND_DEPARTURE_DATE) : undefined : dateRange.filterArguments[0][0].from;
  }
  function updateDepartureDateRule(clonedDataRetriever, dateRange, selectedService) {
    var departureDateRule = _.find(clonedDataRetriever.customSearchCriteria, ['field', 'departureDate']);
    departureDateRule = departureDateRule || _.find(clonedDataRetriever.customSearchCriteria, ['field', 'custom:numberDepartureDate']);
    departureDateRule = departureDateRule || _.find(clonedDataRetriever.customSearchCriteria, ['field', 'numberDepartureDate']);
    if (departureDateRule) {
      departureDateRule.operator = '=';
      departureDateRule.leftOperand = getDepartureDateOperand(dateRange, selectedService);
      departureDateRule.rightOperand = undefined;
    }
  }
  function getDataRetriever(screen, mode, masterData, selectedService) {
    var clonedDataRetriever = cloneDataRetriever(screen, mode, masterData);
    var dateRange = clonedDataRetriever.brushFilters() ? clonedDataRetriever.brushFilters().dateRange : undefined;
    if (dateRange !== undefined || selectedService) {
      // if we see the profile chart it means one day got selected, we shall use it in the API query
      if (!clonedDataRetriever.customSearchCriteria) {
        clonedDataRetriever.customSearchCriteria = currentStateCriteriaService.copySearchCriteria(currentStateCriteriaService.getSearchCriteria()).rules;
      }
      if (selectedService) {
        updateLegMarketRule(clonedDataRetriever, selectedService);
      }
      updateDepartureDateRule(clonedDataRetriever, dateRange, selectedService);
    }
    return clonedDataRetriever;
  }
  function transformData(rawData, selectedMetric, selectedReference) {
    var availablecurves;
    if (flightModeService.isDAOnlyMode()) {
      availablecurves = ProfileChartConstants.DA_AVAILABLE_CURVES[selectedMetric];
    } else {
      availablecurves = ProfileChartConstants.AVAILABLE_CURVES[selectedMetric];
    }
    return _.chain(availablecurves).filter(filterBySelectedReference(selectedReference)).reduce(function (result, curveConfig) {
      var curveData = rawData[curveConfig.name];
      if (_.isArray(curveData) && curveData.length > 0) {
        var dataSet = {
          dotted: curveConfig.dotted,
          curveData: curveData,
          fill: curveConfig.fill,
          pinLineLabel: curveConfig.pinLineLabel,
          className: _.kebabCase(curveConfig.pinLineLabel),
          customDash: curveConfig.customDash
        };
        if (curveConfig.squareIndicatorsType) {
          dataSet.squareIndicatorsType = _.kebabCase(curveConfig.squareIndicatorsType);
        }
        result.push(dataSet);
      }
      return result;
    }, []).value();
  }
  function retrieveData(targetType, screen, mode, masterData, selectedService) {
    return getDataRetriever(screen, mode, masterData, selectedService).retrieveComponentData(targetType);
  }
  function getExpectedCurveData(expectedValue, currentDtd, currentDtdValue) {
    var step = (expectedValue - currentDtdValue) / currentDtd;
    var value = expectedValue;
    var results = [];
    if (_.isNil(currentDtdValue)) {
      return results;
    }
    for (var i = 0; i <= currentDtd; i++) {
      results.push({
        dtd: i,
        value: value
      });
      value -= step;
    }
    return results;
  }
  function filterBySelectedReference(selectedReference) {
    return function (entry) {
      return _.isNil(entry.referenceType) || entry.referenceType === selectedReference;
    };
  }
  function filterBySelectedMetric(selectedMetric) {
    return function (entry) {
      return _.includes(entry.metrics, selectedMetric);
    };
  }
  function getLegendItems(selectedMetric, selectedReference) {
    var legend;
    if (flightModeService.isDAOnlyMode()) {
      legend = ProfileChartConstants.DA_LEGEND_ITEMS;
    } else {
      legend = ProfileChartConstants.LEGEND_ITEMS;
    }
    return _.chain(legend).clone().filter(filterBySelectedReference(selectedReference)).filter(filterBySelectedMetric(selectedMetric)).value();
  }
  function isUrdLabel(legendItem) {
    return legendItem.label === ProfileChartConstants.MIN || legendItem.label === ProfileChartConstants.AVG || legendItem.label === ProfileChartConstants.MAX;
  }
  function buildChartLegend(selectedMetric, selectedReference, legendFilter, transformedData) {
    var result = getLegendItems(selectedMetric, selectedReference);
    var activeItems = _.map(transformedData, 'pinLineLabel');
    _.remove(transformedData, function (data) {
      return _.includes(legendFilter, data.className);
    });
    return _.map(result, function (legendItem) {
      var selected = legendFilter.indexOf(_.kebabCase(legendItem.label)) === -1;
      var disabled = activeItems.indexOf(legendItem.label) === -1;
      if (isUrdLabel(legendItem) && !disabled) {
        disabled = false;
      }
      return buildLegendItem(legendItem, selected, disabled);
    });
  }
  function buildLegendItem(data, selected, disabled) {
    var result = {
      label: data.label,
      id: _.kebabCase(data.label),
      style: ProfileChartConstants.LINE,
      fill: data.fill,
      className: data.fill,
      strokeWidth: ProfileChartConstants.STROKE_WIDTH,
      dashed: data.dashed,
      customDash: data.customDash,
      tooltip: data.label
    };
    if (result.label !== ProfileChartConstants.CURRENT) {
      result.selectable = !disabled;
      result.selected = selected && !disabled;
    }
    if (!result.selected) {
      result.dashed = false;
      result.customDash = undefined;
    }
    return result;
  }
  function buildTooltip(curves, metric) {
    curves = _.chain(curves).orderBy(['value'], ['desc']).map(function (curve) {
      return _.assign(curve, {
        value: !_.isNil(curve.value) ? rmNumberFormat(curve.value, 'NUMBER') : null,
        className: !_.isNil(curve.className) ? 'curve curve-value ' + curve.className : null
      });
    }).value();
    return {
      metric: metric,
      dtd: curves[0] ? curves[0].dtd : '',
      curves: curves,
      isDAOnlyMode: flightModeService.isDAOnlyMode()
    };
  }
  function getMasterData(targetType, screen, mode, dimension, selectedService) {
    selectedDimension = dimension;
    return retrieveData(targetType, screen, mode, null, selectedService).then(function (rawData) {
      return selectedService ? _.filter(rawData, {
        flightId: selectedService.flightId,
        leg: selectedService.leg,
        cabinCode: selectedService.cabinCode
      }) : rawData;
    });
  }
  function saveLegCabinForDefinedLeg(params) {
    return function (masterData) {
      var firstLegCabin = _.first(masterData);
      if (!firstLegCabin || firstLegCabin.isLastYearData) {
        return $q.reject();
      }
      setLegCabin(firstLegCabin);
      return $q.all({
        masterData: masterData,
        rawData: retrieveData(params.target, params.screen, params.subMode, masterData, params.selectedService)
      });
    };
  }
  function processCurveData(params) {
    return function (results) {
      var isDaOnlyMode = flightModeService.isDAOnlyMode();
      var masterData = results.masterData;
      var rawData = results.rawData;
      var selectedMetric = params.selectedMetric;
      var entity = _.first(masterData);
      var selectedReference = params.selectedReference || 'lastYear';
      var currentDtd = entity.daysToDeparture;
      var lca = entity.lowestClassAvailable;
      var currentDtdValue;
      var metrics;
      if (isDaOnlyMode) {
        metrics = ProfileChartConstants.DA_AVAILABLE_CURVES[selectedMetric];
      } else {
        metrics = ProfileChartConstants.AVAILABLE_CURVES[selectedMetric];
      }
      _.forEach(metrics, function (curveConfig) {
        var metricName = curveConfig.name;
        if (_.includes(metricName, 'CurrentYear')) {
          if (rawData[metricName] && rawData[metricName].length > 0) {
            if (curveConfig.prolongWithExpect) {
              currentDtdValue = _.first(rawData[metricName]).value;
            }
            rawData[metricName] = lcaDataService.extendToDtd(rawData[metricName], currentDtd, metricName);
          }
        }
      });
      var transformedData = transformData(lcaDataService.prepareData(rawData, currentDtd, lca), selectedMetric, selectedReference);
      if (currentDtd !== 0 && !isDaOnlyMode) {
        var expectedMetric = _.find(ProfileChartConstants.EXPECTED_METRICS, {
          metric: selectedMetric,
          screens: [params.screen]
        });
        if (!_.isNil(expectedMetric)) {
          var expectedValue = _.reduce(masterData, function (sum, legCabin) {
            sum += legCabin[expectedMetric.name] || 0;
            return sum;
          }, 0);
          var curveData = getExpectedCurveData(expectedValue, currentDtd, currentDtdValue);
          if (!_.isEmpty(curveData)) {
            transformedData.push({
              curveData: curveData,
              dotted: true,
              fill: expectedMetric.fill,
              pinLineLabel: expectedMetric.pinLineLabel,
              className: _.kebabCase(expectedMetric.pinLineLabel)
            });
          }
        }
      }
      lcaDataService.transformLcaCurves(transformedData, rawData);
      return {
        entity: entity,
        data: transformedData,
        legend: params.legendFilter ? buildChartLegend(selectedMetric, selectedReference, params.legendFilter, transformedData) : null
      };
    };
  }
  function getCurveDataWithDefinedMasterData(params, masterData) {
    return saveLegCabinForDefinedLeg(params)(masterData).then(processCurveData(params));
  }
  function getCurveData(params) {
    return getMasterData(params.target, params.screen, params.mode, params.dimension, params.selectedService).then(saveLegCabinForDefinedLeg(params)).then(processCurveData(params));
  }
  function setLegCabin(legCabin) {
    dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.FLIGHT_CABIN_PROFILE_MODE).selectedParams({
      legCabin: legCabin
    });
    dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.FLIGHT_CLASS_PROFILE_MODE).selectedParams({
      legCabin: legCabin
    });
  }
  return {
    getCurveData: getCurveData,
    buildTooltip: buildTooltip,
    getCurveDataWithDefinedMasterData: getCurveDataWithDefinedMasterData
  };
};
ProfileChartDataProviderService.$inject = ['$q', '$filter', 'DataTransformerService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'CurrentStateCriteriaService', 'FeatureToggleService', 'ProfileChartConstants', 'MomentService', 'ProfileChartLowestClassAvailableDataService', 'ProfileChartSearchCriteriaService', 'FlightModeService'];
module.exports = ProfileChartDataProviderService;